import React, { useState, useEffect, useContext} from 'react';
import Layout from './Layout.js';
import Box from '@mui/material/Box';
import socketIO from 'socket.io-client';
 import { apiUrl, apiUrlChat } from './UrlParam.js';
import AxiosFetchData from './AxiosFetchData.js';
import { useParams, useNavigate } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
import alertMsg from '../assets/alert.mp3'
import OnlineIcon from '../../src/assets/img/online.png'
import socket from '../hook/Socket.js'
import {useJWTDecode} from '../hook/GeneralHook.js'
const Chat = () => {
    
    // const socket = socketIO.connect(apiUrl);
   // const socket = SocketIoHook.GetSocketIO();
    //const socket = useContext(SocketContext);
    //const { socket } = useContext(SocketContext);
    const {id} = useParams();
    const {token} = useJWTDecode(id);
    const navigate = useNavigate()
    const [email, setEmail] = useState('');
    const [isOnline, setIsOnline] = useState([]);

    const [from, setFrom] = useState('');

    const [message , setMessage] = React.useState({
        [id] : {
            __html: '',
        }
    });


    const [send, setSend] = useState('');
    const [users, setUsers] = useState([]);
    const [newMessage , setNewMessage] = React.useState({});
    const [count, setCount] = useState([]);
     

    useEffect(() =>
    {
        
        const Token = async () =>{
            try{
                let token = await AxiosFetchData.token().refreshToken(navigate);
                setFrom(token.email);
                setEmail(id)
              
                const chatUsers = await AxiosFetchData.get(`GetChatUsers`,{to:'sss'}).refreshToken(navigate)
                if(chatUsers.data.length > 0){
                    setUsers(chatUsers.data.filter((item)=>item.email != token.email))
                }

                await refresh(token.email)
            
                if(id){
                    await GetChat(token.email, id)
                }

                 socket.emit('login', token.email);

                 socket.on('user_online', (data) => {
                    setIsOnline(data)
                 });
                 //alert(id)
                if(id !="GLOBAL")
                {
                    socket.on(token.email + id, (data) => {
                       
                            handleReceiveChatResp(data.msg.toString().replaceAll(',',''))
                            console.log('tiga')
                       
                     });
                }

                 if(id=="GLOBAL"){
                    //console.log('hai')
                    socket.on('globalchat', (data) => {
                        data.msg.forEach(element => {
                            if(element.from == token.email){
                               // msg = element.replaceAll('float:left','float:right').replaceAll('background: white', 'background: #73AD21')
                                element.message = element.message.replaceAll('float:left','float:right').replaceAll('z:white', 'background: #73AD21')
                              //  element.message = <div>{element.from}</div> + element.message
                            }
                            else{
                                //msg = element.replaceAll('float:right','float:left').replaceAll('background: #73AD21', 'background:white')
                               element.message = element.message.replaceAll('float:right','float:left').replaceAll('background: #73AD21', 'background:white')
                             //  element.message = <div>{element.from}</div> + element.message
                            }
                           // newMsg.push(msg)
                        });
                        //console.log(data.msg.map((item) => item.message))
                        //handleReceiveChatResp(newMsg.toString().replaceAll(',',''))
                        handleReceiveChatResp(data.msg.map((item) => item.message).toString().replaceAll(',',''))
                        console.log('satu')
                     });
                   }

                   
                 socket.on(token.email, async (data) => {
                    if(data.msg[data.msg.length - 1].includes("float:left")){

                      if (document.getElementById('btnPlay'))
                      {
                        document.getElementById("btnPlay").click();
                      }

                    }
                    await refresh(token.email)
                });

            }catch(err){
                console.log(err)
            }
        }

       Token();

       return () => {
        socket.off(token.email);
        socket.off(token.email + id);
        socket.off('globalchat');
        socket.off('user_online');
      };
    },[id]);

    const handleChat = async () =>{
        if(id){
            // var data = {
            //     to:id ,
            //     from :from,
            //     msg : "<div style='text-align:right; padding:10px;' class='col-lg-12'><div style='border-radius: 5px 5px 5px 5px; background: #73AD21;padding: 10px;float:right; box-shadow: 3px 3px'  >" + send.replaceAll("\n","<br/>").replaceAll(" ", "&nbsp;") + "</div></div>",
            // }
            var data = {
                to:id == "GLOBAL" ? null : id,
                from :from,
                msg : "<div style='text-align:right; padding:10px;' class='col-lg-12'><div style='border-radius: 5px 5px 5px 5px; background: #73AD21;padding: 10px;float:right; box-shadow: 3px 3px'  >" + send.replaceAll("\n","<br/>").replaceAll(" ", "&nbsp;") + "</div></div>",
            }

            if(id == "GLOBAL"){
                socket.emit('globalchat', data);
            }else{
                socket.emit('chat', data);
            }
           

            setSend('')
        }else{
            alert("choose email first")
        }
    }

    const handleReceiveChatResp = (data) =>{
        try{
            var data =  {
                [id] : {__html: data}
            }

            setMessage(data)
 
            let scrollableDiv = document.getElementById('modalcontent');
            scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
        }catch(err){
            console.log(err.message)
        }
    }

    const refresh = async (to) => {
        try{
            const response = await AxiosFetchData.get("GetUnreadChat", {to:to}).refreshToken(navigate)
            setCount(response.data)
        }catch(err){
            console.log(err.message)
        }

    }

     const handleGetChat = async(to) =>{
        await SetReadStatus(to,from)
        await refresh(from)
        window.location.href = `${apiUrlChat}/Chat/${to}`
        //props.location.state.newId
      //  navigate(`/Chat/${to}` ,{ state: { to: to }})
       // navigate(`/Chat/${to}` , { replace: true })
     }

     const GetChat = async (from,to)=>{
        var data ={
            from : from,
            to: to
        }
        
        const response = await AxiosFetchData.get("GetChat", data).refreshToken(navigate)

        response.data.forEach(element => {
            if(element.from == from){
                element.message = element.message.replaceAll('float:left','float:right').replaceAll('background: white', 'background: #73AD21')
            }else{
                element.message = element.message.replaceAll('float:right','float:left').replaceAll('background: #73AD21', 'background:white')
            }
        });

        handleReceiveChatResp(response.data.map((item) => item.message).toString().replaceAll(',',''))

    }

    const SetReadStatus= async (from, to)=>{
        try{
            var data = {
                from:from,
                to:to
            }
            const response = await AxiosFetchData.post("SetReadStatus", data).refreshToken(navigate)
        }catch(err){
            console.log(err.message)
        }

    }

    const handlePlayAudio = (e) =>{
        try{
            var myaudio = document.getElementById("AudioID");
            myaudio.play();
        }catch(err){
            console.log(err.message)
        }

    }

    return (
    <Layout>
    <div className='pd'><b>CHAT ROOM</b>

    </div>

    <div className="pd">
    <audio  controls id='AudioID' style={{display:"none"}}><source src={alertMsg} type='audio/mpeg' /></audio>
    <button type='button'  style={{display:"none"}} id="btnPlay"   onClick={handlePlayAudio}/>
      <Box sx={{ width: "100%" }} >
            <table style={{width:"100%"}} >
                <tr>
                    <td width={200}>
                        <table style={{width:"100%"}}>
                            {users.map((row, index) => (
                                <tr>
                                    <td><button className="btn btn-primary mb-1"  onClick={(e)=>{

                                      handleGetChat(row.email)
                                  }
                                  } style={{width:"100%"}}>{isOnline.filter((item)=>item.email == row.email).length > 0 ? <img src={OnlineIcon} width={10} height={10}/> : ""} {row.nama_client}  {count.filter((item) => item.from == row.email).length > 0 ? <Chip size="small" label={count.filter((item) => item.from == row.email).length > 0 ? count.filter((item) => item.from == row.email)[0].counts : 0} /> :''}</button></td>
                                </tr>
                            ))}
                            <tr>
                                <td><button className="btn btn-primary mb-1"  onClick={(e)=>{

                                      handleGetChat("GLOBAL")
                                  }
                                  } style={{width:"100%"}}>GLOBAL</button></td>
                            </tr>

                        </table>
                    </td>
                    <td style={{paddingLeft:5}}>
                        <table style={{width:"100%"}} border={0}>
                            <tr>
                                <td colSpan={2}><b>{(email != null? email:'').toUpperCase()}</b></td>
                            </tr>
                           <tr>
                                <td colSpan={2}>

                                    <Box sx={{width:"100%", height:300, border:1}}>
                                    <div id="modalcontent" dangerouslySetInnerHTML={message[id]} style={{overflowY:"auto", height:300,backgroundColor:"#C0C0C0"}}>

                                    </div>

                                    </Box>
                                </td>
                           </tr>
                           <tr>
                            <td colSpan={2}>&nbsp;</td>
                           </tr>
                           <tr>
                                <td style={{width:"90%"}}>
                                <textarea style={{width:"100%"}} value={send} onChange={(e) => setSend(e.target.value)} rows={2}>

                                </textarea>
                                </td>
                                <td><button style={{width:"100%", height:45}} className="btn btn-primary ml-2" onClick={()=>  handleChat()}>Send</button></td>
                           </tr>
                        </table>

                    </td>
                </tr>
            </table>
      </Box>
    </div>
      </Layout>)

}

export default Chat;